import React, { FC } from 'react'

import { LoginForm } from './Form'
import { useLoginViewErrorHandler } from './errorHandler'

interface LoginViewProps {
  hasError?: boolean
}

export const Login: FC<LoginViewProps> = ({ hasError }) => {
  const { error } = useLoginViewErrorHandler(hasError)

  return <LoginForm error={error} />
}
